module.exports = __webpack_public_path__ + "img/print.8c189914.jpg";